// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "460" ? "quickjs-sandbox" : chunkId) + "." + {"396": "5959c592e5fb7506","460": "ed60826b16acd12f","917": "6d4970822d23046b","985": "b59efd9ebff3cd75",}[chunkId] + ".chunk.js"
}